import { render, staticRenderFns } from "./PostCardExtension.vue?vue&type=template&id=2a1957f6&scoped=true&"
import script from "./PostCardExtension.vue?vue&type=script&lang=js&"
export * from "./PostCardExtension.vue?vue&type=script&lang=js&"
import style0 from "./PostCardExtension.vue?vue&type=style&index=0&id=2a1957f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1957f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
